import React from 'react';
import { DataGrid} from "@material-ui/data-grid";
import { CircularProgress } from '@material-ui/core';
import { Checkbox } from '@material-ui/core';

const DataGridStores = ({data, setData}) => {
  // removidos estados/funções não utilizados
  // console.log('DataGridStores::data', data);
  

  // Dados principais (origin_name, count, status)
  const getRows = () => {
    const items = [...data].map((row, idx) => (
      {
        id: idx,
        isSelected: row?.isSelected,
        origin_name: row?.origin_name,
        count: row?.count,
        status: row?.status,
        message: row?.message,
        orders: row?.orders,
        pickupTemplate: row?.pickupTemplate,
        deliveryTemplate: row?.deliveryTemplate,
      }
    ));
    
    return items;
  }

  const handleChangeSelected = (id) => {
    data[id].isSelected = !data[id].isSelected;
    setData([...data]);
  }

  // Colunas para o DataGrid principal
  const columns = [
    { field: 'isSelected', headerName: '[√]', width: 100,
      renderCell: (param) => (
        <Checkbox checked={param?.row?.isSelected} onChange={() => handleChangeSelected(param?.id)} />
      )
    },
    { field: 'origin_name', headerName: 'Loja', width: 400 },
    { field: 'count', headerName: 'Ordens', width: 150 },
    { field: 'status', headerName: 'Status', width: 200,
      renderCell: (param) => (
        param?.value === 0
        ? <span style={{fontWeight:'bold'}}>Não Processado</span>
        : param?.value === 1 ?
        <span style={{color:'blue', fontWeight:'bold'}}> <CircularProgress size={15} /> Processando...</span>
        :[200, 201, 202].indexOf(param?.value) > -1
        ? <span style={{color:'green', fontWeight:'bold'}}>Processado</span>
        : <span style={{color:'red', fontWeight:'bold'}}>Ocorreu algum erro!</span>
      )
     },
     { field: 'message', headerName: 'Mensagem', width: 350 },
  ];
  return (
    <DataGrid density="compact"
      rows={getRows()}
      columns={columns}
      pageSize={100}
      rowsPerPageOptions={[100]}
      checkboxSelection={false}
      disableSelectionOnClick
    />
  );
};

export default DataGridStores;
